<div class="d-flex justify-content-center align-items-center">
    <div class="d-flex w-100 align-items-center justify-content-between mt-2">
        <div style="flex: 1; height: 1px; background-color: #8f8d8d;"></div>
        <div class="text-center px-2">
            <p style="margin: 0;">OR</p>
        </div>
        <div style="flex: 1; height: 1px; background-color: #8f8d8d;"></div>
    </div>

</div>

<div class="d-flex justify-content-center mt-3">
    <button (click)="loginRedirect()"
        style="display: flex; align-items: center; border: 1px solid #ccc; padding: 4px 10px; border-radius: 4px; background-color: white; cursor: pointer; transition: background-color 0.3s;">
        <img src="../../../assets/logos/ms-logo.svg" alt="Microsoft Logo" style="height: 20px; margin-right: 10px;" />
        <span style=" color: #333;">Continue with Microsoft</span>
    </button>
</div>